import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";

export const Login = ({ onSubmit, loading }) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm();
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const submitData = (data) => {
    onSubmit(data);
    reset({
      email: "",
      password: "",
    });
  };

  return (
    <form className="flex flex-col gap-8" noValidate onSubmit={handleSubmit(submitData)}>
      <Controller
        name="email"
        rules={{
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "Invalid email address",
          },
        }}
        control={control}
        defaultValue={""}
        render={({ field }) => {
          return (
            <TextField
              required
              {...field}
              value={field.value}
              onChange={field.onChange}
              id="filled-required"
              label="Email"
              type="email"
              variant="filled"
              fullWidth
              error={errors.email}
              helperText={errors.email ? errors.email.message : ""}
            // sx={{
            //   "& .MuiTextField-root": {
            //     color: "white",
            //     backgroundColor: "transparent",
            //   },
            //   "& .MuiFilledInput-root": {
            //     color: "white",
            //   },
            //   "& .MuiFilledInput-input": {
            //     color: "white",
            //   },
            //   "& .MuiFilledInput-underline:before": {
            //     borderBottomColor: "white",
            //   },
            //   "& .MuiInputLabel-root": {
            //     color: "#cecece",
            //     fontWeight: "900",
            //   },
            //   "& .MuiInputLabel-root.Mui-focused": {
            //     fontWeight: "bold",
            //     color: "white",
            //   },
            //   // "& .MuiFormLabel-filled": {
            //   //   color: "black",
            //   // },
            //   "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
            //     borderBottomColor: "#cecece",
            //   },
            //   "& .MuiFilledInput-underline:after": {
            //     borderBottomColor: "white",
            //   },
            // }}
            />
          );
        }}
      />
      <Controller
        name="password"
        rules={{
          required: "Password is required",
        }}
        control={control}
        defaultValue={""}
        render={({ field }) => {
          return (
            <TextField
              required
              {...field}
              value={field.value}
              onChange={field.onChange}
              id="filled-password-input"
              label="Password"
              type={showPassword ? "text" : "password"}
              error={errors.password}
              helperText={errors.password ? errors.password.message : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                      className="text-white"
                      sx={{
                        color: "black",
                      }}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="filled"
              fullWidth
            // sx={{

            //   "& .MuiFilledInput-root": {
            //     color: "#cecece",
            //   },
            //   "& .MuiFilledInput-input": {
            //     color: "#cecece",
            //   },
            //   "& .MuiFilledInput-underline:before": {
            //     borderBottomColor: "#cecece",
            //   },
            //   "& .MuiInputLabel-root": {
            //     color: "#cecece",
            //   },
            //   "& .MuiInputLabel-root.Mui-focused": {
            //     color: "white",
            //   },
            //   "& .MuiFilledInput-underline.MuiFilledInput-underline:hover:before": {
            //     borderBottomColor: "#cecece",
            //   },
            //   "& .MuiFilledInput-underline:after": {
            //     borderBottomColor: "white",
            //   },
            // }}
            />
          );
        }}
      />
      <Button
        type="submit"
        className="w-[50%] self-center my-4"
        size="large"
        variant="contained"
        disabled={loading}
        sx={{
          backgroundColor: "#e8442d",
          fontFamily: "Bai Jamjuree",
          color: "white",
          fontWeight: "900",
          "&:hover": {
            backgroundColor: "#e85d01",
          },
          "&:active": {
            backgroundColor: "#e85d01",
          },
        }}
      >
        {loading ? "Logging in..." : "Login"}
      </Button>
    </form>
  );
};
